module.exports = __webpack_public_path__ + "media/points/sync-4469c602.svg";